// src/components/CheckEmail.js
import React from "react";

import { URL_CONSTANTS } from "../utils/constants";
import '../css/account-success.css';

const AccountSuccessComponent = () => {
  return (
    <div class="form-hero-section bg-lblack section-padding account-success">
      <div class="form-container">
        <div class="form-hero-block">
          <div class="form-hero-content">
            <span class="fs-40">You’re in!</span>
            <h2>
              Welcome to Apty’s Content Creation Studio!
            </h2>
            <div>
              <p>Your 15-day free trial starts now</p>
              <p>Dive in and start creating seamless digital experiences for your users</p>
            </div>
            <div>
              <a href={URL_CONSTANTS.LEARN_HOW_TO_USE_APTY} class="button" target="_blank" rel="noopener">Learn How to Use Apty</a>
            </div>
          </div>
          <div class="form-hero-code">
            <div class="step-form-block">
              <div class="form-response">
                <div class="form-response-image">
                  <img src="https://www.apty.io/wp-content/uploads/2025/01/form-success.svg" style={{ maxWidth: '100%' }} alt="" />
                  <div class="form-response-text">
                    <div class="fs-24 fw-500">Successfully registered! </div>
                    <div class="color-text">Your 15-Day Free Trial Begins! </div>
                  </div>
                </div>
                <div class="form-footer mt-60 text-center">
                  <a class="form-btn">Check Your Inbox!</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSuccessComponent;
